import { createComponent, ElementWithProps } from '@carvana/merch-components';

export const LinkCardContainer = createComponent('div', {
  className:
    'flex h-full w-full flex-col gap-xl rounded-[6px] p-2xl text-blue-6 m:gap-2xl'
});

export const HeaderWrapper = createComponent('div', {
  className: 'flex items-center justify-between'
});

export const Header = createComponent('p', {
  className: 'tl-header-m'
});

export const linkStyles = 'text-blue-2 tl-link-m';

export const LinksContainer = createComponent('div', {
  className: 'flex h-full flex-col overflow-hidden'
});

export const LinkBoldCopy = createComponent<
  ElementWithProps & { truncate?: boolean }
>('p', ({ truncate = false, ...rest }) => ({
  className: `tl-header-s ${
    truncate ? 'truncate' : 'max-h-[40px] overflow-hidden'
  }`,
  ...rest
}));

export const CardContainer = createComponent<
  ElementWithProps & { hasFullSetOfCards?: boolean }
>('div', ({ hasFullSetOfCards = false, ...rest }) => ({
  className: `py-xl first:pt-0 last:pb-0 ${
    hasFullSetOfCards ? 'm:my-auto m:py-0 m:first:mt-0 m:last:mb-0' : ''
  }`,
  ...rest
}));

export const LinkCopy = createComponent('p', {
  className: 'truncate tl-body-s'
});
